import { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import SelectionControls from '@gds/SelectionControls/SelectionControls';

import { useAtomValue } from 'jotai';

import { filtersListAtom } from 'Atoms/App/Plp/FiltersListAtom';

import { useUpdateFilters } from 'Hooks/SearchFilters/UseUpdateFilters';

import { trackFilterEvent } from '../../Filters.tracking';

import styles from './PromotionsFilter.module.css';

export const PromotionsFilter = ({ strings, isDisabled, promotionFilter }: any) => {
  const { updateFilters } = useUpdateFilters();
  const filtersList = useAtomValue(filtersListAtom);
  const promotions = promotionFilter?.value;

  const handleChange = (filterId: FilterKey, eventTarget: EventTarget & HTMLInputElement) => {
    const value = eventTarget.checked ? 'true' : undefined;

    trackFilterEvent(filterId, value || 'false', filtersList);
    updateFilters([{ id: filterId, value }]);
  };

  return (
    <div className={styles.toggleWrapper}>
      <div>
        <SelectionControls
          disabled={isDisabled}
          checked={promotions === 'true'}
          label={strings.promotionsFilterLabel}
          onChange={e =>
            handleChange('has-offers-or-promotions', e.target as EventTarget & HTMLInputElement)
          }
          type="switch"
        />
      </div>
    </div>
  );
};
